<ng-container *ngIf="verificationPending">
    <h1>{{'VERIFICATION_INIT.ACCOUNT_NOT_ACTIVE' | translate }}</h1>
    <p>{{'VERIFICATION_INIT.CONTACT_ADMINISTRATOR' | translate}}</p>

    <div class="mb30">
        <app-button (clickEvent)="commonFunc.getRedirectedByRequestId()" [btnOption]="backButtonOptions">
        </app-button>
    </div>

</ng-container>

<ng-container *ngIf="processingType === 'CODE'">
    <div *ngIf="showVerificationList">

        <h1
            *ngIf="verificationMethods.length > 0 && verificationMethods.indexOf('EMAIL') > -1 && verificationMethods.indexOf('SMS') > -1">
            {{'VERIFICATION_INIT.VERIFY_EMAIL_OR_MOBILE' | translate }}</h1>
        <h1
            *ngIf="verificationMethods.length > 0 && verificationMethods.indexOf('EMAIL') > -1 && verificationMethods.indexOf('SMS') === -1">
            {{'VERIFICATION_INIT.VERIFY_EMAIL' | translate }}</h1>
        <h1
            *ngIf="verificationMethods.length > 0 && verificationMethods.indexOf('EMAIL') === -1 && verificationMethods.indexOf('SMS') > -1">
            {{'VERIFICATION_INIT.VERIFY_MOBILE' | translate }}</h1>

        <div *ngIf="verificationMethods.length > 0">
            <ul fxLayout="column" fxLayout.xs="column" fxLayoutGap="0.5rem" class="mfa-list">
                <li (click)="clickMethod(item.toLowerCase())" *ngFor="let item of verificationMethods">
                    <div fxLayoutAlign="center center" fxFlex="20" fxFlex.xs="40">
                        <span class="mfa-icon mfa-icon-list" [ngClass]="'cidaas-icon-'+item.toLowerCase()"></span>
                    </div>
                    <div class="mfa-desc" fxFlex="80" fxFlex.xs="60">
                        <h3 class="mfa-title">
                            {{'MFA_REQUIRED.' + item | translate}}
                        </h3>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!showVerificationList">
        <div *ngIf="initiateVerificationPayload.verificationMedium === 'email'">
            <h1>
                {{'VERIFICATION_INIT.ENTER_EMAIL_TO_PROCEED' | translate }}</h1>

            <app-input (valueEmit)="setCode($event, 'email')" [option]="inputOption.email">
            </app-input>
        </div>
        <div
            *ngIf="initiateVerificationPayload.verificationMedium === 'sms' || initiateVerificationPayload.verificationMedium === 'ivr'">
            <h1>
                {{'VERIFICATION_INIT.ENTER_MOBILE_TO_PROCEED' | translate }}</h1>

            <app-input (valueEmit)="setCode($event, 'mobile')" [option]="inputOption.mobile">
            </app-input>
        </div>

        <div class="mb30">
            <app-button (clickEvent)="showVerificationList=true;" [btnOption]="backButtonOptions">
            </app-button>
            <span class="mr20"></span>
            <app-button (clickEvent)="sendVerificationMedium()" [btnOption]="proceedButtonOption">
            </app-button>
        </div>
    </div>

    <div class="container" fxLayout="row" fxLayoutWrap fxLayoutGap="0.5%" fxLayoutAlign="center">
        <ng-container *ngIf="errorMsg">
            <div class="color-red">
                {{errorMsg | translate}}
            </div>
        </ng-container>
    </div>

</ng-container>

<ng-container *ngIf="processingType === 'LINK' && showVerificationList">
    <h1 *ngIf="verificationMedium === 'email'">
        {{'VERIFICATION_INIT.CONFIRMATION_TO_EMAIL' | translate }}</h1>
    <h1 *ngIf="verificationMedium === 'sms' || verificationMedium === 'ivr'">
        {{'VERIFICATION_INIT.CONFIRMATION_TO_MOBILE' | translate }}</h1>
    <div class="container" fxLayout="row" fxLayoutWrap fxLayoutGap="0.5%" fxLayoutAlign="center">
        <div>
            <app-button (clickEvent)="commonFunc.getRedirectedByRequestId()" [btnOption]="backToLoginButtonOptions">
            </app-button>
        </div>
        <div fxFlex="20%"></div>
        <div>
            <app-button (clickEvent)="clickMethod(verificationMedium)" [btnOption]="resendButtonOptn">
            </app-button>
        </div>
    </div>
</ng-container>
<!-- <div *cidPageLoader="pageLoading"></div>-->
